export const ScadenzaFiltroWarningDays = 30;

export const ScadenzaAnalisiWarningDays = 30;
